<template>
  <div class="form-group taxes-selector">
    <label class="form-control-label"> {{ label }} </label>
    <div
      v-for="(transaction, key) in transactionsModel"
      :key="key"
      class="taxes-wrapper"
    >
      <div class="form-group-item row name">
        <div class="col-6">
          <base-input
            :label="`${(transaction.refund ? $t('COMMON.REFUND') : $t('COMMON.AMOUNT'))} (*)`"
            :placeholder="(transaction.refund ? $t('COMMON.REFUND') : $t('COMMON.AMOUNT'))"
            v-model="transaction.amount"
            type="number"
            @change="transactionsChanged"
            @blur="checkAmount"
          >
          </base-input>
        </div>
        <div class="col-6">
          <base-input
            :label="`${$t('PROPERTIES_PAYMENTS.SOURCE')} (*)`"
            :placeholder="$t('PROPERTIES_PAYMENTS.SOURCE')"
          >
            <el-select
              :clearable="true"
              class="select-primary pagination-select"
              :placeholder="$t('PROPERTIES_PAYMENTS.SOURCE')"
              v-model="transaction.source"
              @change="transactionsChanged"
            >
              <el-option
                class="select-primary"
                v-for="(item, key) in PROPERTIES_PAYMENTS_SOURCES"
                :key="key"
                :label="$t(`PROPERTIES_PAYMENTS.PAYMENT_SOURCE_${item}`)"
                :value="item"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
      </div>

      <div class="remove-taxes-button">
        <base-button
          type="button"
          class="form-control btn btn-danger"
          :disabled="transactionsModel?.length === 1"
          @click.prevent="() => removeTransaction(key)"
        >
          <i class="fal fa-times"></i>
        </base-button>
      </div>
    </div>
    <base-button
      :disabled="currentTotal >= parseFloat(property?.total).toFixed(2)"
      type="button"
      class="btn add"
      @click.prevent="addTransaction"
    >
      <i class="far fa-plus"></i>
    </base-button>
  </div>
</template>

<script>
import { Option, Select } from "element-ui";
import { PROPERTIES_PAYMENTS_SOURCES } from "@/constants/propertiesPayment";
import BaseInput from "@/components/Inputs/BaseInput.vue";

export default {
  name: "property-payment-inputs",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    BaseInput,
  },

  props: {
    property: {
      type: [Object],
      default: null,
      description: "Property",
    },
    label: {
      type: String,
      default: null,
      description: "Label of field",
    },
    totalDue: {
      type: String,
      default: null,
      description: "Total due",
    },
  },

  data() {
    return {
      transactionsModel: [],
      PROPERTIES_PAYMENTS_SOURCES,
    };
  },

  setup() {},

  mounted() {},

  created() {
    this.transactionsModel = [];
    if(parseFloat(this.totalDue) != 0){
      this.transactionsModel.push({
        refund: this.totalDue < 0 ? true : false,
        amount: parseFloat(this.totalDue).toFixed(2),
        source: null,
      });
      this.transactionsChanged();
    }
    this.$root.$on("handleRefundAmount", ({ clearPayments, addPayment, refund, refundAmount }) => {
      if(addPayment){
        this.transactionsModel.push({
          refund: refund,
          amount: refundAmount,
          source: null,
        });
      }else if(clearPayments){
        this.transactionsModel= [];
      }else{
        let totalRefund = parseFloat(this.transactionsModel[this.transactionsModel.length - 1].amount) + refundAmount;
        this.transactionsModel[this.transactionsModel.length - 1].amount = totalRefund;
      }
      this.transactionsChanged();
    });
  },

  computed: {
    currentTotal() {
      return this.transactionsModel.reduce(
        (sum, item) => sum + parseFloat(item.amount),
        0
      );
    },
  },

  methods: {
    checkAmount(){
      const totalWithoutRefundProperty = this.transactionsModel.reduce((sum, transaction) => {
        if (transaction.refund === undefined || !transaction.refund) {
          sum += transaction.amount;
        }
        return sum;
      }, 0);
      const totalWithRefundTrue = this.transactionsModel.reduce((sum, transaction) => {
        if (transaction.refund === true) {
          sum += transaction.amount;
        }
        return sum;
      }, 0);
      const balance = parseFloat(this.totalDue) - parseFloat(totalWithoutRefundProperty);
      const totalProperiesAmount =
        this.transactionsModel.reduce(
          (sum, item) => parseFloat(sum) + (item.refund ? (-parseFloat(item.amount)) : parseFloat(item.amount)),
          0
        ).toFixed(2);
      const refundAmount = parseFloat(totalProperiesAmount).toFixed(2) - parseFloat(this.totalDue).toFixed(2);
      const hasRefund = this.transactionsModel.some(transaction => transaction.refund === true);
        if (refundAmount > 0 && !hasRefund) {
          this.transactionsModel.push({
            refund: true,
            amount: balance.toFixed(2),
            source: null,
          });
        }
        const index = this.transactionsModel.findIndex(transaction => transaction.refund === true);

        if (index !== -1) {
          // Modifier la propriété amount à 10
          this.transactionsModel[index].amount = balance.toFixed(2);
        }
        if(balance == 0){
          const index = this.transactionsModel.findIndex(transaction => transaction.refund === true);

          if (index !== -1) {
            // Si un objet avec refund true existe, on le supprime
            this.transactionsModel.splice(index, 1);
          }
        }
        this.transactionsChanged();
    },
    async addTransaction() {
      const totalProperiesAmount =
        this.transactionsModel.reduce(
          (sum, item) => parseFloat(sum) + (item.refund ? -parseFloat(item.amount) : parseFloat(item.amount)),
          0
        ).toFixed(2);
      const amount = (parseFloat(this.totalDue) - parseFloat(totalProperiesAmount)).toFixed(2);
      this.transactionsModel.push({
        amount: amount,
        source: null,
      });
      this.transactionsChanged();
    },

    removeTransaction(key) {
      this.transactionsModel = this.transactionsModel.filter(
        (_, idx) => idx !== key
      );
      this.transactionsChanged();
    },

    transactionsChanged() {
      const transactionsData = this.transactionsModel.map((item) => {
        return { ...item, amount: parseFloat(item.amount) };
      });
      this.$emit("transactionsChanged", transactionsData);
    },
  },

  watch: {},
};
</script>

<style lang="scss">
.form-group {
  &.taxes-selector {
    > label {
      display: block;
      font-size: 16px;
      margin-bottom: 10px;
    }

    .form-group-item {
      flex: 1;
      padding: 0 10px;
      .el-select {
        margin-top: 0px;
      }
      &.remove {
        max-width: 53px;
      }
    }

    .remove-taxes-button {
      padding-left: 10px;
      button {
        box-shadow: none;
        border: none;
        margin: 0;
        &.btn-danger {
          width: 43px;
          height: 43px;
          border-radius: 8px;
          background-color: #f5365c;
          margin-bottom: 0;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          i {
            font-size: 20px;
            color: #fff;
          }
        }
      }
    }

    button {
      &.add {
        width: 43px;
        height: 43px;
        border-radius: 8px;
        background-color: #000;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 15px 0 0 0;
        i {
          font-size: 18px;
          color: #fff;
        }
      }
    }
  }

  .taxes-wrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin: 10px 0 0 0;

    .form-group-item {
      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }

    &:first-child {
      margin-top: 15px;
    }

    .form-group {
      margin-bottom: 0;
    }
  }
}
</style>
